const Language_CN = {
    WalletAccountName: {
        "-2": "DeFi钱包",
        "-1": "总览",
        "0": "游戏账户",
        "1": "交易账户"
    },
    COMMON: {
        Save: "保存",
        Coin: '币种',
        Common: '通用',
        Amount: '数量',
        Confirm: '确定',
        Setting: '设置',
        Wallet: '钱包',
        Funds: '资金',
        Markets: '行情',
        Trade: '交易',
        Topup: '充值',
        Withdraw: '提现',
        Transfer: '划转',
        Send: '发送',
        Create: "创建",
        equityValue: '估值',
        withdrawAmount: '提现金额',
        sendAmount: '发送金额',
        sendTotal: '全部发送',
        SendAccount: '发送账户',
        RecvAccount: '接收账户',
        SelSendAccount: '选择发送账户',
        SelRecvAccount: '选择接收账户',
        Balance: '余额',
        topupAccount: "充值账户",
        withdrawAccount: "提现账户",
        sendAddress: "发送地址",
        recvAddress: "接收地址",
        transferNet: "转账网络",
        address: "地址",
        signature: "交易签名",
        serviceFee: "网络手续费",
        date: "日期",
        logout: "退出登录",
        backup: "备份",
        cancel: "取消",
        import: "导入",
        ok: "好的",
        walletAddress: "钱包地址",
        coinList: "币种列表",
        notEnoughBalance: '余额不足',
    },
    Order: {
        confirm: "确认订单",
        willReceive: "您将收到",
        sendFrom: "发送来源",
        sendCoin: "发送币种",
        totalAmount: "总额",
        transferTip: "请确保您输入了正确的地址，并且地址与转账网络相匹配。订单创建后不可取消。",
        doingTransaction: "正在进行中的交易",
    },
    UI: {
        Login: {
            title: "NexGami Wallet 登录",
            email: "邮箱",
            password: "密码",
            login: "登录",
            registerNow: "立即注册",
            forget: "忘记密码",
            emailError: "请输入正确的邮箱地址",
            passwordNeed: "请输入密码",
            passwordError: "至少8位字符，且必须包含1位大写字母及1位数字",
            emailValid: "邮箱验证",
            inputCode: "请输入您在邮箱 %1 收到的6位验证码，验证码5分钟有效",
            verificationCode: "验证码",
            varifyFailed: "验证失败",
            verifyReason: "您输入的验证码有误",
            sent: "验证码已发送",
            resend: "重新发送",
            commit: "提交",
            successful: "注册成功",
            successfulTip: "注册成功，请登录",
        },
        Register: {
            title: "创建 NexGami 账户",
            referral: "推荐码(可选)",
            register: "注册"
        },
        WalletView: {
            myDefiWallet: "我的DeFi钱包",
            defiWallet: "DeFi钱包",
            assets: "资产",
            nfts: "NFT",
            recoveryPhrase: "助记词",
            privateKey: "私钥",
            recoveryTip: "为了保护您的钱包，请将助记词保存在不同的地点。",
            recoveryPkTip: "为了保护您的钱包，切户泄露您的秘钥。",
            phraseTip: "这12个词语是进入您钱包的钥匙。不要与任何人分享它。我们永远不会向您索要您的助记词。",
            phrasePkTip:"Never disclose this key. Anyone with your private keys can steal any assets held in your account.",
            phraseShow: "点按可显示助记词",
            phrasePkShow: "点按可显示私钥",
            phraseScreen: "确保没有人在看您的屏幕。",
            backupTip: "备份助记词以保护您的资产",
            resetWallet: "重置钱包",
            resetTip: "在您重置钱包前，请确认已经备份助记词。",
            phraseCopied: "已复制到剪贴板",
            resetMsg: "请确保您已经备份了您的钱包，重置钱包后，您将不能再访问钱包以及资产，该动作不能被撤销。您只能通过助记词来恢复您的钱包，NexGami不会保存您的助记词。",
            btnReset: "重置我的钱包",
            dialogResetTitle: "确认重置",
            dialogResetMsg: "您确定要重置钱包吗？该动作不能被撤销。",
            dialogBtnReset: "重置钱包",
            addressCopied: "钱包地址已复制到剪切板",
            copyAddress: "复制地址",
        },
        CreateWalletView: {
            welcome: "欢迎使用DeFi钱包",
            create: "创建新的DeFi钱包",
            import: "导入钱包",
            inputPhrase: "输入助记词",
            inputPhraseTip: "创建钱包时，您会获得由12个单词组成的助记词。",
            inputTip: "输入助记词中的所有单词，以空格分割。",
            importSuccess: "您已成功导入钱包！",
            wrongPhrase: "无效的助记词",
        },
        TopupView: {
            title: "选择充值币种",
            will_topup: "您将充值",
            order_submitted: "订单已提交",
            coin_list_title: "币种列表",
            coin_list_title_right: "DeFi钱包余额",
        },
        WithdrawView: {
            title: "选择提现币种",
            title_send: "选择发送币种",
            sameAddress: "检测到本次交易的发送来源和接收地址是同一地址，请检查是否正确。",
            recvAddressTip: "输入地址，长按粘贴",
            checkAddressTip: "请检查钱包地址，钱包地址必须和主网络匹配",
        },
        TransactionDetailView: {
            title: "%1详情",
        },
        TransactionHistoryView: {
            title: "交易记录",
            transactionHistory: '点击此处查看完整交易记录',
        },
        FundView: {
            topup_tip: "请激活DeFi钱包后使用充值功能。",
        },
        ProfileMenu: {
            referralCode: "推广码",
            referralLink: "推广链接",
            codeCopied: "推广码已复制到剪切板",
            linkCopied: "推广链接已复制到剪切板",
        },
        AddressBookView: {
            newAddress: "新增地址",
            editAddress: "修改地址",
            universalAddr: "通用地址，适用于全部币种。",
            setAsUniversal: "设置为通用地址",
            addressSource: "地址来源(可选)",
            addressTag: "地址标签",
            inputTag: "请输入地址标签，以方便记忆和管理。",
            successful: "地址 %1 添加成功。",
        }
    },
    Msg: {
        Trade_NotEnoughCoin: "您的 %1 中 %2 币的余额不足，不足以支付本次的网络手续费，请划转至少 %3 到您的 %1 中。",
        Trade_AmountTooSmall: "您的交易金额太少，不足以支付本次的网络手续费，您本次的交易金额至少为 %1。",
    },

    Code: {
        DefiWallet: {
            type: "DefiWallet",
            [-1]: "错误的请求",
            [-2]: "区块链访问错误，请稍候重试...",
            [-3]: "签名验证失败",
            [-4]: "没有找到请求的订单",
            [-5]: "订单状态错误",
            [-6]: "发送失败，发送金额有误",
        },
        TransactionMethod: {
            type: "TransactionMethod",
            [-1]: "错误",
            [0]: "处理中",
            [1]: "处理中",
            [2]: "待确认",
            [3]: "已确认",
            [4]: "发货中",
            [5]: "已完成",
        }
    }
}

const Language_EN = {
    WalletAccountName: {
        "-2": "NexGami Wallet",
        "-1": "Overview",
        "0": "Game Wallet",
        "1": "Spot Wallet"
    },
    COMMON: {
        Save: "Save",
        Coin: 'Coin',
        Common: 'Universal',
        Amount: 'Amount',
        Confirm: 'Confirm',
        Setting: 'Settings',
        Wallet: 'Wallet',
        Funds: 'Funds',
        Markets: 'Markets',
        Trade: 'Trade',
        Topup: 'Deposit',
        Withdraw: 'Withdraw',
        Transfer: 'Transfer',
        Send: 'Send',
        Create: 'Create',
        equityValue: "Equity Value",
        withdrawAmount: 'Amount',
        sendAmount: 'Amount',
        sendTotal: 'Total',
        SendAccount: 'Send From',
        RecvAccount: 'Send To',
        SelSendAccount: '选择发送账户',
        SelRecvAccount: '选择接收账户',
        Balance: 'Available',
        topupAccount: "充值账户",
        withdrawAccount: "Send From",
        sendAddress: "发送地址",
        recvAddress: "Address",
        transferNet: "Network",
        address: "Address",
        signature: "Hash",
        serviceFee: "Network fee",
        date: "Date",
        logout: "Log Out",
        backup: "Backup",
        cancel: "Cancel",
        import: "Import",
        ok: "OK",
        walletAddress: "Wallet Address",
        coinList: "Coin List",
        notEnoughBalance: 'Insufficient balance',
    },
    Order: {
        confirm: "Confirm order",
        willReceive: "You receive",
        sendFrom: "Source",
        sendCoin: "Coin",
        totalAmount: "Amount",
        transferTip: "Ensure that the address is correct and on the same network. Transactions cannot be cancelled",
        doingTransaction: "Transactions",
    },
    UI: {
        Login: {
            title: "NexGami Wallet Login",
            email: "Email",
            password: "Password",
            login: "Login",
            registerNow: "Create NexGami Wallet Account",
            forget: "Forgot password?",
            emailError: "Please enter a correct email address",
            passwordNeed: "Please input password",
            passwordError: "Password must be at least 8 characters where 1 upper case letter and 1 number",
            emailValid: "Verify",
            verificationCode: "Verification Code",
            inputCode: "Please enter the 6-digit verification code you received in your emial %1",
            varifyFailed: "Failed",
            verifyReason: "The verification code is incorrect",
            resend: "Resend",
            sent: "Sent",
            commit: "Submit",
            successful: "Successful",
            successfulTip: "Please login",
            failed: "Failed",
            failedReason: "Username or password is incorrect.",
        },
        Register: {
            title: "Create NexGami Account",
            referral: "Referral Code(Optional)",
            register: "Create NexGami Account"
        },
        WalletView: {
            myDefiWallet: "My NexGami Wallet",
            defiWallet: "NexGami Wallet",
            assets: "Assets",
            nfts: "NFT",
            recoveryPhrase: "Recovery Phrase",
            privateKey: "Private Key",
            recoveryTip: "Protect your wallet by saving your Recovery Phrase in various places like on a piece of paper.",
            recoveryPkTip:"Protect your wallet, Never disclose this key.",
            phraseTip: "This 12-word phrase represents your private key and grants you access to your wallet.Do not share your private key with anyone. We will never ask for your Recovery Phrase.",
            phrasePkTip:"Never disclose this key. Anyone with your private keys can steal any assets held in your account.",
            phraseShow: "Tap to reveal your Recovery Phrae",
            phrasePkShow: "Tap to reveal your Private Key",
            phraseScreen: "Make sure no one is watching your screen.",
            backupTip: "Backup the recovery phrase to secure your assets",
            resetWallet: "Reset Wallet",
            resetTip: "Secure your recovery phrase before you reset the wallet.",
            phraseCopied: "copied to clipboard",
            resetMsg: "Please make sure you have already backed up your wallet. After reset your wallet, you will no longer be able to access the wallet and assets. This action cannot be undone. You can only recovery this wallet with your recovery phrase backup. NexGami does not save your recovery phrase.",
            btnReset: "Reset My Wallet",
            dialogResetTitle: "Confirm Reset",
            dialogResetMsg: "Are you sure you want to reset the wallet? This action cannot be undone",
            dialogBtnReset: "Reset",
            addressCopied: "Copied to clipboard",
            copyAddress: "Copy Address",
        },
        CreateWalletView: {
            welcome: "Welcome to NexGami Wallet",
            create: "Create New NexGami Wallet",
            import: "Import",
            inputPhrase: "Enter Recovery Phrase",
            inputPhraseTip: "This is a 12-word recovery phrase given to you when creating your wallet.",
            inputTip: "Enter all words from your Recovery Phrase separated by spaces.",
            importSuccess: "您已成功导入钱包！",
            wrongPhrase: "Invalid Recovery Phrase",
        },
        TopupView: {
            title: "Coins",
            will_topup: "您将充值",
            order_submitted: "Order has been submitted",
            coin_list_title: "Coin List",
            coin_list_title_right: "NexGami Wallet Available",
        },
        WithdrawView: {
            title: "Coins",
            title_send: "Coins",
            sameAddress: "检测到本次交易的发送来源和接收地址是同一地址，请检查是否正确。",
            recvAddressTip: "Long press to paste",
            checkAddressTip: "The withdrawal addres format is wrong. Please check the withdrawal address length and character content.",
        },
        TransactionDetailView: {
            title: "%1 Details",
        },
        TransactionHistoryView: {
            title: "History",
            transactionHistory: 'Tap here to explor the transactions'
        },
        FundView: {
            topup_tip: "请激活DeFi钱包后使用充值功能。",
        },
        ProfileMenu: {
            referralCode: "Referral Code",
            referralLink: "Referral Link",
            codeCopied: "Copied to clipboard",
            linkCopied: "Copied to clipboard",
        },
        AddressBookView: {
            newAddress: "New Address",
            editAddress: "Edit Address",
            universalAddr: "Universal Address",
            setAsUniversal: "Set as universal address,withou specific coins.",
            addressSource: "Address Origin (Optional)",
            addressTag: "Wallet Label",
            inputTag: "Please input the wallet label.",
            successful: "saved",
        }
    },
    Msg: {
        Trade_NotEnoughCoin: "You do net have enough %2 to pay the network fee. Transfer %3 to your %1 first.",
        //Trade_NotEnoughCoin: "您的 %1 中 %2 币的余额不足，不足以支付本次的网络手续费，请划转至少 %3 到您的 %1 中。",
        Trade_AmountTooSmall: "您的交易金额太少，不足以支付本次的网络手续费，您本次的交易金额至少为 %1。",
    },

    Code: {
        DefiWallet: {
            type: "DefiWallet",
            [-1]: "错误的请求",
            [-2]: "区块链访问错误，请稍候重试...",
            [-3]: "签名验证失败",
            [-4]: "没有找到请求的订单",
            [-5]: "订单状态错误",
            [-6]: "发送失败，发送金额有误",
        },
        TransactionMethod: {
            type: "TransactionMethod",
            [-1]: "Error",
            [0]: "Pending",
            [1]: "Pending",
            [2]: "Confirming",
            [3]: "Confirmed",
            [4]: "Sending",
            [5]: "Completed",
        }
    }
}
export const Language = {
    CN: "cn",
    EN: "en",
}

const languages = {
    cn: Language_CN,
    en: Language_EN,
}

export let Localize = {
    CurrentLanguage: Language.CN,
    ...Language_CN,

    changeLanguage: (l) => {
        if (Localize.CurrentLanguage != l) {

            const lang = languages[l];

            if (lang != null) {
                Localize.CurrentLanguage = l;
                Localize = {
                    ...Localize,
                    ...lang,
                }
            }
        }
    },

    /**
     * 
     * @param {String} msg 
     * @param  {...String} replacements 
     */
    getMsg: (msg, ...replacements) => {
        let ret = msg;
        for (let i = 1; i <= replacements.length; i++) {
            ret = ret.replace(new RegExp("%" + i, "gm"), replacements[i - 1]);
        }
        return ret;
    },

    getCodeMsg: (type, code) => {
        let ret = Localize.Code[type];
        if (ret == null) return "";
        return ret[code];
    },

    /**
     * 根据路径获取值，路径格式为 xxx.xx 例如COMMON.Topup
     * @param {string} msgPath 
     */
    getMsgByPath: (msgPath) => {
        const path = msgPath.split(".");
        let msg = Localize;
        for (var p in path) {
            msg = msg[path[p]];
            if (msg == null) {
                break;
            }
        }
        if (typeof (msg) == 'string')
            return msg;
        else
            return "";
    }
}

Localize.changeLanguage(Language.EN);


export const LocalStr = ({ msg, className, replacements }) => {
    if (replacements == null)
        replacements = [];
    const str = Localize.getMsg(msg, ...replacements);
    return <div className={className}>{str}</div>
}